import React from 'react';
import { CircularProgress, Link, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink } from 'react-router-dom';
import { fetchOrganization } from '../../organizations/dataHandlers/getOrganizationHandler';
import { formatOrganizationLabel } from '../../../utils/organization';

export default function SubscriptionOrganizationCell({ stripeCustomerId }) {
  const { data: organization, isLoading } = useQuery({
    queryKey: ['organization', stripeCustomerId],
    queryFn: () => fetchOrganization({ queryKey: ['organization', stripeCustomerId] }),
    enabled: Boolean(stripeCustomerId),
    retry: false,
  });

  if (!stripeCustomerId) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  const label = formatOrganizationLabel(organization?.name, organization?.email);
  const displayLabel = label === '-' ? stripeCustomerId : label;

  return (
    <Link
      component={RouterLink}
      to={`/organizations/${stripeCustomerId}`}
      underline="hover"
      variant="body2"
      title={displayLabel}
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {displayLabel}
    </Link>
  );
}
